import gql from "graphql-tag"
import fullDeal from "@irati/deals/services/queries/fragments/fullDeal"

const query = gql`
  query GetPerksGoPromotionalDeals($limit: Int, $sort: DealListSort) {
    perksGoPromotionalDeals(limit: $limit, sort: $sort) {
      count
      offset
      results {
        ...fullDeal
      }
    }
  }
  ${fullDeal}
`

export default query
